import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=112b5b0c&scoped=true&"
import script from "./RightSideBar.vue?vue&type=script&lang=js&"
export * from "./RightSideBar.vue?vue&type=script&lang=js&"
import style0 from "./RightSideBar.vue?vue&type=style&index=0&id=112b5b0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112b5b0c",
  null
  
)

export default component.exports